import moment from 'moment';

export const KEYS = {
  USER: 'USER',
  CLIENT_VERSION: 'CLIENT_VERSION',
};

export default {
  KEYS,
  get(key) {
    const item = localStorage.getItem(key);

    try {
      return JSON.parse(item);
    } catch (e) {
      return item;
    }
  },
  set(key, value) {
    try {
      const json = JSON.stringify(value);
      localStorage.setItem(key, json);
    } catch (e) {
      localStorage.setItem(key, value);
    }
  },
  remove(key) {
    localStorage.removeItem(key);
  },
};
